/* global util */

// eslint-disable-next-line no-var
var LoginIdpForm = function() {
  this.init = function(loginUrl, isLinking, thirdPartyUrl, providedUsername) {
    let hasFieldError = false;
    let username = util.getUsernameFromSession();
    if (providedUsername) {
      username = providedUsername;
    }
    const form = document.getElementById('rh-password-verification-form');
    const password = document.getElementById('password');
    const passwordSpan = document.getElementById('password-error');
    const submitButton = document.getElementById('rh-password-verification-submit-button');
    const usernameDomEl = document.getElementById('username');
    if (!usernameDomEl.value && username) {
      usernameDomEl.value = username;
    }

    util.addPasswordToggle();
    $('#rh-pw-edit-username').on('click tap dbltap longtap', () => {
      if(loginUrl) {
        window.location =  loginUrl;
      }
    });
      
    form.addEventListener('submit', e => {
      if (isLinking) {
        submitButton.prop("disabled", true);
        util.hideFormErrorMessage();
        util.hideFieldErrorMessage(password, passwordSpan);
        if (hasFieldError) {
          hasFieldError = false;
        }
        if (!util.isPasswordVerificationFormValid()) {
          e.preventDefault();
          hasFieldError = true;
          util.showFieldErrorMessage(password, passwordSpan, password.attr('data-msg-required'));
          submitButton.prop("disabled", false);
          return false;
        }
      } else {
        e.preventDefault();
        if (usernameDomEl && usernameDomEl.value) {
          util.setUsernameToSession(usernameDomEl.value);
        }
        if (thirdPartyUrl) {
          window.location = thirdPartyUrl
        }
      }
    });
  }
}

// eslint-disable-next-line no-var, no-unused-vars
var loginIdpForm = new LoginIdpForm();
